export const stepsProdutoData = [
    {
        title: 'Achou um bom desconto para um produto?',
        description: 'Clique em "Ver Produto". Ao clicar, uma janela será aberta.',
        imageSrc: 'https://static.meucupom.com/media/2026%20-%20Updates/novo-site/produto_passo_1.png',
    },
    {
        title: 'Ir para o site',
        description: 'Dentro da janela, clique no botão "Ver Produto" para entrar na página do produto na loja.',
        imageSrc: 'https://static.meucupom.com/media/2026%20-%20Updates/novo-site/produto_passo_2.png',
    },
];